import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LoadingComponent } from './components/loading/loading.component';
import { DragulaModule } from 'ng2-dragula';
import { ColorPickerModule } from 'ngx-color-picker';
import { FormsModule } from '@angular/forms';
import { ConfiguratorComponent } from './components/configurator/configurator.component';
import { ToolsMenuComponent } from './components/configurator/tools-menu/tools-menu.component';
import { ColorPanelComponent } from './components/configurator/panels/color-panel/color-panel.component';
import { TextPanelComponent } from './components/configurator/panels/text-panel/text-panel.component';
import { ImagePanelComponent } from './components/configurator/panels/image-panel/image-panel.component';
import { LayersPanelComponent } from './components/configurator/panels/layers-panel/layers-panel.component';
import { ShapePanelComponent } from './components/configurator/panels/shape-panel/shape-panel.component';
import { ToolsBarComponent } from './components/configurator/tools-bar/tools-bar.component';
import { ToolTipComponent } from './components/configurator/tool-tip/tool-tip.component';
import { ManagerPanelComponent } from './components/configurator/manager-panel/manager-panel.component';
import { PrintPanelComponent } from './components/configurator/panels/print-panel/print-panel.component';
import { SavePanelComponent } from './components/configurator/panels/save-panel/save-panel.component';
import { LabelCanvasComponent } from './components/configurator/label-canvas/label-canvas.component';
import { SheetPreview } from './components/configurator/sheet-preview.component';
import { LabelPreview } from './components/configurator/label-preview.component';
import { ConfiguratorService } from './services/configurator.service';
import { PrintService } from './services/print.service';
import { ModalComponent } from './components/ui/modal/modal.component';
import { AccordionItemComponent } from './components/ui/accordion/accordion-item.component';
import { AccordionComponent } from './components/ui/accordion/accordion.component';
import { ProgressComponent } from './components/ui/progress/progress.component';
import { PaginationComponent } from './components/ui/pagination/pagination.component';
import { AngularResizeEventModule } from 'angular-resize-event';
import { ApplicationData } from './data/application.data';
import { UserData } from './data/user.data';
import { ModalService } from './services/modal.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrandPipe } from './tools/brand.pipe';
import { ExcelPanelComponent } from './components/configurator/panels/excel.panel/excel-panel.component';
import { ReplacePipe } from './tools/replace.pipe';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, environment.ASSETS_SERVER+'/assets/locales/messages.', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    ConfiguratorComponent,
    ToolsMenuComponent,
    ColorPanelComponent,
    TextPanelComponent,
    ImagePanelComponent,
    LayersPanelComponent,
    ShapePanelComponent,
    ToolsBarComponent,
    ToolTipComponent,
    ManagerPanelComponent,
    PrintPanelComponent,
    SavePanelComponent,
    ExcelPanelComponent,
    LabelCanvasComponent,
    SheetPreview,
    LabelPreview,
    ModalComponent,
    AccordionItemComponent,
    AccordionComponent,
    ProgressComponent,
    PaginationComponent,
    BrandPipe,
    ReplacePipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    DragulaModule.forRoot(),
    AngularResizeEventModule,

    FormsModule,
    ColorPickerModule
  ],
  providers: [
    ConfiguratorService,
    PrintService,
    ApplicationData,
    UserData,
    ModalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
